import {observable, action, computed} from 'mobx';
import {t, types} from 'shared/core';
import {DomainStore} from 'shared/store';
import {successAlert} from 'shared/tools';

class TeamContainerState {
  scope;
  match;
  store = new DomainStore();

  @observable cycle;
  @observable shareWithRevieweeModalOpen = false;
  @observable reviewee;

  receiveProps({match, cycle, scope}) {
    this.match = match;
    this.scope = scope;
    this.cycle = cycle;
  }

  @action async shareWithReviewee(reviewee) {
    const review = await this.store.post(
      reviewee.link('share'),
      types.PERFORMANCE_REVIEWS.REVIEWEE
    );

    if (review) {
      this.interactiveAgent.refresh();
      this.closeShareWithRevieweeModal();
      successAlert(t('performance_reviews.view.alerts.Reviews have been shared!'));
    }
  }

  @action openShareWithRevieweeModal(reviewee) {
    this.reviewee = reviewee;
    this.shareWithRevieweeModalOpen = true;
  }

  @action closeShareWithRevieweeModal() {
    this.shareWithRevieweeModalOpen = false;
  }

  setInteractiveAgent(interactiveAgent) {
    this.interactiveAgent = interactiveAgent;
  }

  @computed get revieweeName() {
    if (!this.reviewee) {
      return null;
    }

    return this.reviewee.employee.name;
  }

  @computed get managerReviewerName() {
    if (!this.reviewee || !this.reviewee.managerReview) {
      return null;
    }

    return this.reviewee.managerReview.reviewer.name;
  }

  @computed get canShareReviewee() {
    if (!this.reviewee) {
      return false;
    }

    return this.reviewee.hasLink('share');
  }
}

export default TeamContainerState;
